import { Badge } from '@/components/ui/badge';
import { useTeammate } from '@/hooks/useTeammate';
import { observer } from 'mobx-react-lite';
import { useMemo, useState } from 'react';
import { CheckIcon } from '@heroicons/react/solid';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { getBadgeColor } from '@/constants';

const data = [
  { id: 1, name: 'Active' },
  { id: 2, name: 'Away' },
];

const TableMenu = ({
  user,
  status,
  workspaceCreatorId,
  user_id,
}: {
  user: any;
  status: string;
  workspaceCreatorId: string;
  user_id: string | undefined;
}) => {
  const [selected, setSelected] = useState(
    data.find(s => s.name === status) || data[0],
  );
  const { teammateStatus } = useTeammate();

  const handleTeammateStatus = (selectedStatus: (typeof data)[number]) => {
    setSelected(selectedStatus);
    teammateStatus({
      userId: user?._id,
      status: selectedStatus.name,
    });
  };

  const isDisabled = useMemo(() => {
    const isOwner = workspaceCreatorId === user_id;
    if (isOwner) return false;
    return user?._id !== user_id;
  }, [user, workspaceCreatorId, user_id]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger disabled={isDisabled} className='focus:outline-none'>
        <Badge
          variant='outline'
          className={`flex items-center space-x-2  text-[13px] w-[78px]
            cursor-${isDisabled ? 'not-allowed' : 'pointer'}
            ${getBadgeColor(selected.name)}`}
        >
          <div className='w-2 h-2 rounded-full bg-current' />
          <span className='capitalize'>{selected.name.toLowerCase()}</span>
        </Badge>
      </DropdownMenuTrigger>

      <DropdownMenuContent className='w-36 gap-y-2 ml-10'>
        {data.map(item => (
          <DropdownMenuItem
            key={item.id}
            onSelect={() => handleTeammateStatus(item)}
            className='flex items-center justify-between cursor-pointer text-md'
          >
            <span
              className={`${
                selected.name === item.name ? 'text-secondary' : ''
              }`}
            >
              {item.name}
            </span>
            {selected.name === item.name && (
              <CheckIcon
                className='h-5 w-5 text-secondary font-bold'
                aria-hidden='true'
              />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default observer(TableMenu);
